/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetUserSessionIssuerAttachImpactSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetUserSessionIssuerAttachImpactSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetUserSessionIssuerAttachImpactSecurity = {
  option1?: GetUserSessionIssuerAttachImpactSecurityOption1 | undefined;
  option2?: GetUserSessionIssuerAttachImpactSecurityOption2 | undefined;
};

export type GetUserSessionIssuerAttachImpactRequest = {
  /**
   * The MCP server the issuer would be attached to.
   */
  mcpServerId?: string | undefined;
  /**
   * The toolset the issuer would be attached to.
   */
  toolsetId?: string | undefined;
  /**
   * The meta MCP server the issuer would be attached to.
   */
  metaMcpServerId?: string | undefined;
  /**
   * The issuer to attach. Omit to preview detaching the current issuer.
   */
  userSessionIssuerId?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetUserSessionIssuerAttachImpactSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetUserSessionIssuerAttachImpactSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetUserSessionIssuerAttachImpactSecurityOption1$Outbound,
    GetUserSessionIssuerAttachImpactSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getUserSessionIssuerAttachImpactSecurityOption1ToJSON(
  getUserSessionIssuerAttachImpactSecurityOption1:
    GetUserSessionIssuerAttachImpactSecurityOption1,
): string {
  return JSON.stringify(
    GetUserSessionIssuerAttachImpactSecurityOption1$outboundSchema.parse(
      getUserSessionIssuerAttachImpactSecurityOption1,
    ),
  );
}

/** @internal */
export type GetUserSessionIssuerAttachImpactSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetUserSessionIssuerAttachImpactSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetUserSessionIssuerAttachImpactSecurityOption2$Outbound,
    GetUserSessionIssuerAttachImpactSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getUserSessionIssuerAttachImpactSecurityOption2ToJSON(
  getUserSessionIssuerAttachImpactSecurityOption2:
    GetUserSessionIssuerAttachImpactSecurityOption2,
): string {
  return JSON.stringify(
    GetUserSessionIssuerAttachImpactSecurityOption2$outboundSchema.parse(
      getUserSessionIssuerAttachImpactSecurityOption2,
    ),
  );
}

/** @internal */
export type GetUserSessionIssuerAttachImpactSecurity$Outbound = {
  Option1?:
    | GetUserSessionIssuerAttachImpactSecurityOption1$Outbound
    | undefined;
  Option2?:
    | GetUserSessionIssuerAttachImpactSecurityOption2$Outbound
    | undefined;
};

/** @internal */
export const GetUserSessionIssuerAttachImpactSecurity$outboundSchema:
  z.ZodMiniType<
    GetUserSessionIssuerAttachImpactSecurity$Outbound,
    GetUserSessionIssuerAttachImpactSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        GetUserSessionIssuerAttachImpactSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        GetUserSessionIssuerAttachImpactSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function getUserSessionIssuerAttachImpactSecurityToJSON(
  getUserSessionIssuerAttachImpactSecurity:
    GetUserSessionIssuerAttachImpactSecurity,
): string {
  return JSON.stringify(
    GetUserSessionIssuerAttachImpactSecurity$outboundSchema.parse(
      getUserSessionIssuerAttachImpactSecurity,
    ),
  );
}

/** @internal */
export type GetUserSessionIssuerAttachImpactRequest$Outbound = {
  mcp_server_id?: string | undefined;
  toolset_id?: string | undefined;
  meta_mcp_server_id?: string | undefined;
  user_session_issuer_id?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetUserSessionIssuerAttachImpactRequest$outboundSchema:
  z.ZodMiniType<
    GetUserSessionIssuerAttachImpactRequest$Outbound,
    GetUserSessionIssuerAttachImpactRequest
  > = z.pipe(
    z.object({
      mcpServerId: z.optional(z.string()),
      toolsetId: z.optional(z.string()),
      metaMcpServerId: z.optional(z.string()),
      userSessionIssuerId: z.optional(z.string()),
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      gramProject: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        mcpServerId: "mcp_server_id",
        toolsetId: "toolset_id",
        metaMcpServerId: "meta_mcp_server_id",
        userSessionIssuerId: "user_session_issuer_id",
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        gramProject: "Gram-Project",
      });
    }),
  );

export function getUserSessionIssuerAttachImpactRequestToJSON(
  getUserSessionIssuerAttachImpactRequest:
    GetUserSessionIssuerAttachImpactRequest,
): string {
  return JSON.stringify(
    GetUserSessionIssuerAttachImpactRequest$outboundSchema.parse(
      getUserSessionIssuerAttachImpactRequest,
    ),
  );
}
